import React from 'react';
import ErrorBoundary from '../../Common/Organism/ErrorBoundary';
import ComboPlan from './ComboPlan';
import TarjetaInfo from './Tarjeta';
import InfoAContinuacion from './InfoAContinuacion';
import ImagenSuperior from './ImagenSuperior';
import LegalesUpselling from './LegalesUpselling';
import Breadcrumb from '../../Common/Modules/Breadcrumb';
import TitleWeb from '../../Common/Web/Title';
import Button from '../../Common/Modules/Button';

const Planes = ({
    NombreActual,
    NombreUpsell,
    CantidadCredencialesActual,
    CredencialesPlanUpsell,
    PrecioActual,
    PrecioUpsell,
    Tarjeta,
    CredencialCategoria,
    ConfirmarPlan,
    PlanDeVenta,
}) => {

    const armarFeature = (crendencial) =>{
        let feature = [
         `${crendencial} cuentas con <b>Acceso Digital</b>`,
            `${crendencial} credenciales <b>Premium Club LA NACION</b>`
          ]
        return feature;
    }


    return (
        <>
            <div className="upselling">

                <section>
                    <ImagenSuperior cantidad={CredencialesPlanUpsell} />
                    <div className="planes">
                        <div className="caja-ex plan-actual">
                            <ComboPlan
                                cantCredenciales={CantidadCredencialesActual}
                                titulo={NombreActual}
                                features= {armarFeature(CantidadCredencialesActual)}//{FeaturesActual}
                                precio={PrecioActual}
                            />
                        </div>
                        <div className={`caja-ex plan-nuevo ${NombreUpsell === 'Black Familiar' && 'black-familiar'}`}>
                            <ComboPlan
                                cantCredenciales={CredencialesPlanUpsell}
                                titulo={NombreUpsell}
                                features={armarFeature(CredencialesPlanUpsell)}
                                precio={PlanDeVenta[1].PrecioConDescuentos}
                                cantidadDeMeses={PlanDeVenta[1].CantDespachos}
                                precioFinal={PrecioUpsell}
                            />
                        </div>
                    </div>

                    <div className="proximos-pasos">
                        <InfoAContinuacion categoriaCredencial={CredencialCategoria} precio={PlanDeVenta[1].PrecioConDescuentos} />

                        <ErrorBoundary>
                            <TarjetaInfo tarjeta={Tarjeta} />
                        </ErrorBoundary>

                        <div className="pasos-botones">
                            <Button
                                tag="input"
                                mod=" --fivexs --primary --mt-16 --mb-0"
                                onClick={ConfirmarPlan}
                                value="CONFIRMAR NUEVO PLAN"
                                type="submit"
                                mobileW100={true}
                            />
                        </div>
                    </div>

                    <LegalesUpselling />
                </section>
            </div>
        </>
    );
};

export default Planes;
